// The points a piece can be at on the production progress board, in the order the cloth moves.
// Mirrors TMSWeb.Common.Constants.ProductionProgressPoints - the API sends these on every piece,
// so the two must stay in step.
export enum ProductionProgressPoints {
  unconfirmed = 'Unconfirmed',
  notStarted = 'NotStarted',
  yarnIssued = 'YarnIssued',
  warped = 'Warped',
  inLoom = 'InLoom',
  woven = 'Woven',
  perched = 'Perched',
  mended = 'Mended',
  atFinish = 'AtFinish',
  inWarehouse = 'InWarehouse',
  inStock = 'InStock',
  despatched = 'Despatched',
  cancelled = 'Cancelled',
}
